import { ReactNode } from 'react';

const NudgeMessageBlock = ({
    children,
    className,
    onClick,
}: {
    children: ReactNode;
    className?: string;
    onClick?: () => void;
}) => {
    return (
        <div
            className={`text-white p-4 rounded-lg ${className}`}
            style={{
                backgroundImage: 'linear-gradient(to right, #65738C, #949DAF)',
            }}
            onClick={onClick}
        >
            {children}
        </div>
    );
};

export default NudgeMessageBlock;
